import * as $ from "jquery";
import * as d3 from "d3";
import OL from "./lib/ol";
import * as CSVFileDownload from "./csvFileDownload";

function CeptaaMap() {
  var mMapLayers;
  var mMembersList;
  var mMapView;
  var mMap;
  var mMapLayersList;
  var mStreetMapLyrLabel = "Street Map";
  var mLocationsLyrLabel = "Locations Map";
  var publicAPI = {};

  mMapLayersList = [
    {
      Label: "Street Map",
      Index: 0,
      LayerID: 0
    },
    { Label: "Locations Map", Index: 1, LayerID: 1 }
  ];

  function getJsonFile(fname) {
    return new Promise((resolve, reject) => {
      d3.json(
        fname,
        (data) => {
          return resolve(data);
        },
        (err) => {
          return reject("there was a problem loading the file.", err);
        }
      );
    });
  }

  function addStreetMapLyr() {
    var streetBaseMapLyrIndex;
    var streetBaseMapLyr;

    streetBaseMapLyrIndex = mMapLayersList.find(function(d) {
      return d.Label === mStreetMapLyrLabel;
    }).Index;
    streetBaseMapLyr = new OL.layer.Tile({
      title: mStreetMapLyrLabel,
      source: new OL.source.OSM()
    });
    mMapLayers[streetBaseMapLyrIndex] = streetBaseMapLyr;
  }

  function createCSV() {
    var csvArray = [];
    var csvRow;
    var downloadFileName;
    var csvFileDownload;
    var csvConfig;
    var cleanedAddress;
    var cleanedCity;
    var cleanedState;
    var cleanedPostalCode;
    var id = 1;

    mMembersList.forEach(function(member) {
      cleanedAddress = member.Address ? member.Address : "";
      cleanedCity = member.City ? member.City : "";
      cleanedState = member.State ? member.State : "";
      cleanedPostalCode = member["Postal code"] ? member["Postal code"] : "";
      csvRow =
        id +
        "," +
        // member.Name +
        // "," +
        cleanedAddress +
        "," +
        cleanedCity +
        "," +
        cleanedState +
        "," +
        cleanedPostalCode;

      csvArray.push(csvRow);
      id += 1;
    });

    csvArray = csvArray.join("\r\n");
    downloadFileName = "CeptaaAddresses.csv";

    // 26Jul2020
    csvFileDownload = new CSVFileDownload();
    csvConfig = {
      CSVContent: csvArray,
      Filename: downloadFileName
    };
    csvFileDownload.downloadCSV(csvConfig);
  }

  function getLocationFeatColl() {
    var featColl = [];
    var point;
    var feat;
    var symbolStyle;
    var coord;
    // var addresses = [];
    // var person;

    /*  // 16Sep2020 symbolStyle = new OL.style.Style({
      image: new OL.style.Circle({
        radius: 9,
        fill: new OL.style.Fill({ color: "blue" }),
        stroke: new OL.style.Stroke({
          color: [0, 0, 255],
          width: 2
        })
      })
    }); */

    mMembersList.forEach(function(member) {
      coord = OL.proj.fromLonLat([member.Long, member.Lat]);
      point = new OL.geom.Point(coord);
      feat = new OL.Feature(point);
      // 16Sep2020 feat.setStyle(symbolStyle);
      featColl.push(feat);

      /* person = {
        Name: member.Name,
        Address:
          member.Address +
          "," +
          member.City +
          "," +
          member.State +
          "," +
          member["Postal code"]
      };

      addresses.push(person); */
    });
    // 16Sep2020 console.table(addresses);

    return featColl;
  }

  async function addLocationsLyr() {
    var locationsLyrIndex;
    var locationsLyr;
    var featuresColl;
    var featSource;
    var clusterSource;
    var clusterDistance = 25;
    var mStyleCache = {};

    featuresColl = getLocationFeatColl();

    /* var coord = OL.proj.fromLonLat([-84, 33]);
    var point = new OL.geom.Point(coord);
    var feat = new OL.Feature({
      geometry: point
    });
    feat.setStyle(symbolStyle); */

    locationsLyrIndex = mMapLayersList.find(function(d) {
      return d.Label === mLocationsLyrLabel;
    }).Index;

    /*  // 16Sep2020 locationsLyr = new OL.layer.Vector({
      title: "Locations",
      source: new OL.source.Vector({
        features: featuresColl,
        overlaps: false
      })
    }); */

    featSource = new OL.source.Vector({
      features: featuresColl
      // overlaps: false
    });

    clusterSource = new OL.source.Cluster({
      distance: parseInt(clusterDistance, 10),
      source: featSource
    });

    locationsLyr = new OL.layer.Vector({
      title: "Locations",
      source: clusterSource,
      style: function(feature) {
        var size = feature.get("features").length;
        var style = mStyleCache[size];
        if (!style) {
          style = new OL.style.Style({
            image: new OL.style.Circle({
              radius: 10,
              stroke: new OL.style.Stroke({
                color: "#fff"
              }),
              fill: new OL.style.Fill({
                color: "blue"
              })
            }),
            text: new OL.style.Text({
              text: size.toString(),
              fill: new OL.style.Fill({
                color: "#fff"
              })
            })
          });
          mStyleCache[size] = style;
        }
        return style;
      }
    });

    mMapLayers[locationsLyrIndex] = locationsLyr;
  }

  function displayMapTooltip(evt) {
    var pixel;
    var feature;

    pixel = mMap.getEventPixel(evt.originalEvent);
    feature = mMap.forEachFeatureAtPixel(pixel, function(feat, layer) {
      return feat;
    });

    /* var coord = feature.getGeometry().getCoordinates();
    coord = OL.proj.transform(coord, "EPSG:3857", "EPSG:4326");
    var lon = coord[0];
    var lat = coord[1]; */

    if (
      !feature ||
      !Object.prototype.hasOwnProperty.call(feature.getProperties(), "Name")
    ) {
      return;
    }

    // console.log(feature.get("Name"));
  }

  function zoomToMapExtent() {
    var layerExtent;
    var locationsLyrSource;
    var locationsLyrIndex;

    locationsLyrIndex = mMapLayersList.find(function(d) {
      return d.Label === mLocationsLyrLabel;
    }).Index;

    locationsLyrSource = mMapLayers[locationsLyrIndex].getSource();
    layerExtent = locationsLyrSource.getExtent();
    mMapView.fit(layerExtent, {
      size: mMap.getSize()
    });
  }

  async function loadMap() {
    mMapLayers = [];
    addStreetMapLyr();
    await addLocationsLyr();

    mMapView = new OL.View({
      center: OL.proj.fromLonLat([-95.7129, 37.0902]),
      zoom: 4.0
    });

    mMap = new OL.Map({
      layers: mMapLayers,
      target: "map",
      view: mMapView
    });

    mMap.getControls().forEach(function(control) {
      if (control instanceof OL.control.Attribution) {
        mMap.removeControl(control);
      }
    }, this);

    mMap.on("singleclick", function(evt) {
      displayMapTooltip(evt);
    });

    // 23Sep2020 zoomToMapExtent();
  }

  async function loadMembersList() {
    mMembersList = await getJsonFile("members_list.json");
    // console.log(mMembersList);
  }

  publicAPI.init = function() {
    loadMembersList().then(loadMap);
    // 17Sep2020 loadMembersList().then(createCSV);
  };

  return publicAPI;
}
export default CeptaaMap;



// WEBPACK FOOTER //
// ./scripts/ceptaamap.js